module.exports = __webpack_public_path__ + "img/yj_score_bg.b6e989a7.png";